import styled, { css } from 'styled-components'

interface Props {
  widthPer: number
  border: boolean
  [key: string]: any
}

export const StBaseTable = styled.table<Props>`
  width: 100%;
  width: ${({ widthPer }) => widthPer && widthPer + '%'};
  padding: 0;
  * {
    font-size: 0.85rem;
  }
  thead {
    background-color: #ececec;
    padding: 6px 13px;
    tr th {
      border-left: 1px solid #cccccc;
      border-right: 1px solid #cccccc;
      border-bottom: 1px solid #cccccc;
      &:first-child {
        border-left: none;
      }
      &:last-child {
        border-right: none;
      }
      ${({ border }) =>
        border &&
        css`
          border: 1px solid #cccccc;
          &:first-child {
            border-left: 1px solid #cccccc;
          }
          &:last-child {
            border-right: 1px solid #cccccc;
          }
        `}
      padding: 12px 13px;
    }
  }

  tbody {
    tr td {
      border-left: 1px solid #cccccc;
      border-right: 1px solid #cccccc;
      border-bottom: 1px solid #cccccc;
      &:first-child {
        border-left: none;
      }
      &:last-child {
        border-right: none;
      }

      ${({ border }) =>
        border &&
        css`
          border: 1px solid #cccccc;
          &:first-child {
            border-left: 1px solid #cccccc;
          }
          &:last-child {
            border-right: 1px solid #cccccc;
          }
        `}
      text-align: center;
      margin: 0;
      padding: 20px 13px;
    }
  }

  tbody {
    td {
      vertical-align: middle;
    }
  }

  tr th :first-child,
  tr td :first-child {
    margin-top: 0;
  }
  tr th :last-child,
  tr td :last-child {
    margin-bottom: 0;
  }
`
